interface SectionHeaderProps {
  title: string;
  action?: React.ReactNode;
}

export const SectionHeader = ({ title, action }: SectionHeaderProps) => (
  <div className="flex items-center justify-between mb-6">
    <h2 className="text-xl font-medium text-dark-text">{title}</h2>
    {action}
  </div>
);
